import { useMutation, useQueryCache } from 'react-query';
import { WushuStyleAPI } from 'api/admin/wushuStyle';
import { WUSHU_STYLES } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useUpdateEvent() {
  const queryCache = useQueryCache();

  return useMutation(WushuStyleAPI.update, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      queryCache.invalidateQueries(WUSHU_STYLES);
      dispatchToast({ message, type: 'success' });
      onSuccess();
    },
  });
}
